import React from 'react';

import { Hero } from '@/components/Section/Section';

export const LoadingHero = (): JSX.Element => (
  <Hero paddedBottom>
    <div className="pageloader" />
  </Hero>
);
